import {
  HomeFilled, ContractFilled, DocListFilled, SettingsFilled, DocAddFilled, Settings2Filled,
  LineChartArrowFilled, ReportBarChartFilled, UsersLined,
  ClipboardFilled, UsersFilled, ToolsFilled, BasketFilled, WatchFilled,
  WarningFilled,
  CheckTickFilled,
  HistoryFilled,
  LineChartSolid2Filled,
  Database2Filled, ItemListFilled, AlignLFilled,
  CirclePauseFilled,
  IndentLLined
} from '@tag/tag-icons';

import { EnvUtils } from '@/utils/env.utils';
import { UserRole } from '@/config/roles.config';

type Tag4Icon = React.ForwardRefExoticComponent<React.RefAttributes<SVGElement>>;

export interface MenuItem {
  text: string;
  icon: Tag4Icon;
  link?: string;
  collapsable?: boolean;
  indent?: number;
  defaultExpanded?: boolean;
  children?: MenuItem[];
  accessLevel: UserRole[];
}

const allUserRoles = [UserRole.ADMIN, UserRole.READER, UserRole.USER, UserRole.FULL_ACCESS];

let menuItems: MenuItem[] = [
  {
    text: 'Home',
    icon: HomeFilled,
    link: '/',
    accessLevel: allUserRoles
  },
  {
    text: 'Contracts',
    icon: ContractFilled,
    collapsable: true,
    defaultExpanded: true,
    accessLevel: allUserRoles,
    children: [
      {
        text: 'Add Contract',
        icon: DocAddFilled,
        link: '/contracts-bc/add-contract',
        indent: 1,
        accessLevel: [UserRole.ADMIN, UserRole.FULL_ACCESS]
      },
      {
        text: 'Contracts',
        icon: DocListFilled,
        link: '/contracts-bc',
        indent: 1,
        accessLevel: allUserRoles,
      },
      {
        text: 'Contract Lines',
        icon: AlignLFilled,
        link: '/contract-lines',
        indent: 1,
        accessLevel: allUserRoles,
      },
      {
        text: 'Bundles',
        icon: IndentLLined,
        link: '/bundles',
        indent: 1,
        accessLevel: allUserRoles,
      },
    ],
  },
  {
    text: 'Customers',
    icon: UsersFilled,
    collapsable: true,
    defaultExpanded: true,
    accessLevel: allUserRoles,
    children: [
      {
        text: 'Customers',
        icon: UsersLined,
        link: '/customers-new',
        indent: 1,
        accessLevel: allUserRoles
      },
      {
        text: 'Purchase Orders',
        icon: ItemListFilled,
        link: '/purchase-orders',
        indent: 1,
        accessLevel: allUserRoles,
      },
    ],
  },

  {
    text: 'Products',
    icon: BasketFilled,
    link: '/products',
    accessLevel: allUserRoles,
  },
  {
    text: 'Uplifts',
    icon: LineChartSolid2Filled,
    collapsable: true,
    defaultExpanded: true,
    accessLevel: allUserRoles,
    children: [
      {
        text: 'Uplifts History',
        icon: HistoryFilled,
        link: '/uplifts-history',
        indent: 1,
        accessLevel: allUserRoles
      },
      {
        text: 'Uplifts Manager',
        icon: LineChartArrowFilled,
        link: '/uplifts-manager',
        indent: 1,
        accessLevel: [UserRole.ADMIN, UserRole.FULL_ACCESS],
      },
      {
        text: 'Uplift Rates',
        icon: ReportBarChartFilled,
        link: '/uplift-rates',
        indent: 1,
        accessLevel: allUserRoles,
      },
    ]
  },
  {
    text: 'Billing Cycles',
    icon: ClipboardFilled,
    link: '/billing-cycles',
    accessLevel: allUserRoles,
  },
  {
    text: 'Variable Billing',
    icon: ToolsFilled,
    link: '/variable-billing',
    accessLevel: allUserRoles,
  },
  {
    text: 'Billing',
    icon: ReportBarChartFilled,
    collapsable: true,
    defaultExpanded: true,
    accessLevel: allUserRoles,
    children: [
      {
        text: 'Sales Orders (OLD)',
        icon: ClipboardFilled,
        link: '/billing-new',
        indent: 1,
        accessLevel: allUserRoles,
      },
      {
        text: 'Failed',
        icon: WarningFilled,
        link: '/billing-new-failed',
        indent: 2,
        accessLevel: allUserRoles,
      },
      {
        text: 'Scheduled',
        icon: WatchFilled,
        link: '/billing-new-scheduled',
        indent: 2,
        accessLevel: allUserRoles,
      },
      {
        text: 'Sent',
        icon: CheckTickFilled,
        link: '/billing-new-sent',
        indent: 2,
        accessLevel: allUserRoles,
      },
      {
        text: 'Sales Orders',
        icon: ClipboardFilled,
        link: '/billing-bc',
        indent: 1,
        accessLevel: allUserRoles,
      },
      {
        text: 'Failed',
        icon: WarningFilled,
        link: '/billing-bc-failed',
        indent: 2,
        accessLevel: allUserRoles,
      },
      {
        text: 'Paused',
        icon: CirclePauseFilled,
        link: '/billing-bc-paused',
        indent: 2,
        accessLevel: allUserRoles,
      },
      {
        text: 'Scheduled',
        icon: WatchFilled,
        link: '/billing-bc-scheduled',
        indent: 2,
        accessLevel: allUserRoles,
      },
      {
        text: 'Sent',
        icon: CheckTickFilled,
        link: '/billing-bc-sent',
        indent: 2,
        accessLevel: allUserRoles,
      },
    ]
  },
  {
    text: 'Settings',
    icon: SettingsFilled,
    collapsable: true,
    defaultExpanded: true,
    accessLevel: allUserRoles,
    children: [
      {
        text: 'System Admin',
        icon: Settings2Filled,
        link: '/system-admin',
        indent: 1,
        accessLevel: allUserRoles,
      },
      {
        text: 'Client Databases',
        icon: Database2Filled,
        link: '/client-databases',
        indent: 1,
        accessLevel: [UserRole.ADMIN, UserRole.FULL_ACCESS]
      }
    ],
  },
];

// temporary hide item in production env.
if (EnvUtils.azureEnvIs('production')) {
  const menuItemToHideInProd = '/contracts-bc/add-contract';
  const parent = menuItems.find((el) => {
    return el.children?.find((childEl) => childEl.link === menuItemToHideInProd);
  });

  if (parent?.children) {
    parent.children = parent.children.filter((el) => el.link !== menuItemToHideInProd);
  }
}


if (!EnvUtils.isUpliftRatesEnabled()) {
  const menuItemToHideInProd = '/uplift-rates';
  const parent = menuItems.find((el) => {
    return el.children?.find((childEl) => childEl.link === menuItemToHideInProd);
  });

  if (parent?.children) {
    parent.children = parent.children.filter((el) => el.link !== menuItemToHideInProd);
  }
}

export {
  menuItems
};
